import {useEffect} from "react";
import {Form, InputNumber} from "antd";
import initLabelStyles from "./SettingsFormHelper";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import getSettingsItem from "./SettingsItem";
import ResultTable from "../Table/ResultTable";

export default function ({onValuesChange, values, defValues}) {
    return (
        <>
            <div id={'defaults-places-div'}>
                <ResultTable>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>Variable</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left'}}>User Preference</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left'}}>System Default</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'left'}}>Description</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            getSettingsItem({
                                value: values?.max_submergence_ratio,
                                defaultValue: defValues?.max_submergence_ratio,
                                onChange: (value) => {onValuesChange('max_submergence_ratio', value)},
                                label: 'Max Submergence Ratio',
                                description: 'MSR-001, MSR-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.contraction_ratio,
                                defaultValue: defValues?.contraction_ratio,
                                onChange: (value) => {onValuesChange('contraction_ratio', value)},
                                label: 'Contraction Ratio',
                                description: 'T-CES-001',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.expansion_ratio,
                                defaultValue: defValues?.expansion_ratio,
                                onChange: (value) => {onValuesChange('expansion_ratio', value)},
                                label: 'Expansion Ratio',
                                description: 'T-CES-001',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.cont_coef_natural_xs,
                                defaultValue: defValues?.cont_coef_natural_xs,
                                onChange: (value) => {onValuesChange('cont_coef_natural_xs', value)},
                                label: 'Contraction Coeff for Natural XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.exp_coef_natural_xs,
                                defaultValue: defValues?.exp_coef_natural_xs,
                                onChange: (value) => {onValuesChange('exp_coef_natural_xs', value)},
                                label: 'Expansion Coeff for Natural XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.cont_coef_structure_xs,
                                defaultValue: defValues?.cont_coef_structure_xs,
                                onChange: (value) => {onValuesChange('cont_coef_structure_xs', value)},
                                label: 'Contraction Coeff for Structure XS',
                                description: 'CEC-002',
                                min: 0,
                                max: 5
                            })
                        }
                        {
                            getSettingsItem({
                                value: values?.exp_coef_structure_xs,
                                defaultValue: defValues?.exp_coef_structure_xs,
                                onChange: (value) => {onValuesChange('exp_coef_structure_xs', value)},
                                label: 'Expansion Coeff for Structure XS',
                                description: 'CEC-001',
                                min: 0,
                                max: 5
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </div>
        </>
    )
}